import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/css/fonts.css";
import "@/scss/theme.scss";
import "./registerServiceWorker";
import router from "./router";
import store from "./store/index";
import "../index.css";
import AxiosUtilInterceptors from "./Utils/axios-util-interceptors";
import "@vuepic/vue-datepicker/dist/main.css";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker';
// vuetify
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1A4C5E',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        }
      }
    }
  },
});

createApp(App)
  .use(store)
  .use(vuetify)
  .use(router)
  .use(Vue3PersianDatetimePicker, {
    name: 'PersianDatePicker',
    props: {
      format: 'YYYY-MM-DD HH:mm',
      displayFormat: 'jYYYY-jMM-jDD',
      editable: false,
      inputClass: 'form-control persian-date-picker',
      altFormat: 'YYYY-MM-DD HH:mm',
      color: '#2C5A6B',
      autoSubmit: true,
    }
  })
  // .component('DatePicker', Vue3PersianDatetimePicker)
  .mount("#app");
AxiosUtilInterceptors();
